import {
  Box,
  Button,
  Flex,
  Grid,
  GridItem,
  Input,
  InputGroup,
  InputLeftElement,
  Skeleton,
  Tab,
  Table,
  TableCaption,
  TableContainer,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Tbody,
  Td,
  Text,
  Tfoot,
  Th,
  Thead,
  Tr,
  Link,
  Select,
  Checkbox,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  Badge,
  UnorderedList,
  ListItem,
  ButtonGroup,
} from "@chakra-ui/react";
import { useNavigate, useParams } from "react-router-dom";
import { IoChevronBackCircleSharp } from "react-icons/io5";
import axios from "axios";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { LinkIcon } from "@chakra-ui/icons";

const ForwardNode = ({
  forwardNodes,
  isChildNode,
  parentNodes,
  searchTcNumber,
  fullTraceDetails
}) => {
  if (!forwardNodes || forwardNodes.length === 0) {
    if (isChildNode) {
      return null; // Stop recursion if there are no child forward nodes
    }
    if (!parentNodes || parentNodes.length === 0) {
      return <>No Forward Trace Available</>; // Show message if there are no parent or child nodes
    }
  }

  const filteredNodes = forwardNodes.filter((node) =>
    node?.tcNumber?.includes(searchTcNumber)
  );
  const remainingNodes = forwardNodes.filter(
    (node) => !node?.tcNumber?.includes(searchTcNumber)
  );

  return (
    <>


    {/* parent nodes of given TC Number */}
      <Box bg={"brand.lightPowderBlue"}>
        <Accordion allowMultiple defaultIndex={isChildNode ? undefined : [0]}>
          {parentNodes?.map((node, index) => (
            <AccordionItem key={node?._id}>
              <h2>
                <AccordionButton>
                  <>
                    <Box
                      flex="1"
                      textAlign="left"
                      fontWeight="bold"
                      color={isChildNode ? "blue.500" : "black"}
                    >
                      {node?.tcNumber} - {node?.process}
                    </Box>
                    <Button
                      onClick={() => {
                        window.open(`/preview-tc/${node?.tcNumber}`, "_blank");
                      }}
                    >
                      <LinkIcon />
                    </Button>
                  </>
                </AccordionButton>
              </h2>
              <AccordionPanel>
                <Box ml={4} my={2}>
                  <Text fontWeight="bold">Seller Details:</Text>
                  <Text ml={4} my={2}>
                    {node?.seller?.name} {`(${node?.seller?.license})`}
                  </Text>
                  <Text fontWeight="bold"> Buyer Details: </Text>

                  <Text ml={4} my={2}>
                    {node?.buyer?.name} {`(${node?.buyer?.license})`}
                  </Text>
                </Box>
                {node?.procurements && node?.procurements?.length > 0 && (
                  <UnorderedList listStyleType="none" ml={4} my={2}>
                    {node?.procurements?.map((item) => (
                      <ListItem key={item?._id}>
                        <Badge colorScheme="green">{item?.id}</Badge>
                        <Box ml={4} my={4}>
                          <Text fontWeight={"bold"} fontSize={"sm"}>
                            Procurement Supplier:
                          </Text>

                          <Text fontSize={"sm"}>
                            {" "}
                            {`${item?.procurement_supplier?.firstName} ${item?.procurement_supplier?.lastName}`}
                          </Text>
                        </Box>
                      </ListItem>
                    ))}
                  </UnorderedList>
                )}
                {node?.inventory && node?.inventory?.length > 0 && (
                  <UnorderedList listStyleType="none" ml={4} my={2}>
                    {node?.inventory?.map((item) => (
                      <ListItem key={item?._id}>
                        <Badge colorScheme="green">{item.id}</Badge>-{" "}
                        {item?.inventory_productClassification?.name} -{" "}
                        {item.quantityReceived}Kg
                      </ListItem>
                    ))}
                  </UnorderedList>
                )}

                <ForwardNode forwardNodes={node.forwardNodes} isChildNode />
              </AccordionPanel>
            </AccordionItem>
          ))}
        </Accordion>
      </Box>

      {/* current node */}
      <Box>
      <Accordion allowMultiple defaultIndex={isChildNode ? undefined : [0]}>
              <AccordionItem key={fullTraceDetails?._id}>
                <h2>
                  <AccordionButton>
                    <>
                      <Box
                        flex="1"
                        textAlign="left"
                        fontWeight="bold"
                        color={"black"}
                      >
                        {fullTraceDetails?.tcNumber} -{" "}
                        {fullTraceDetails?.process} (Current Node)
                      </Box>
                      <Button
                        onClick={() => {
                          window.open(
                            `/preview-tc/${fullTraceDetails?.tcNumber}`,
                            "_blank"
                          );
                        }}
                      >
                        <LinkIcon />
                      </Button>
                    </>
                  </AccordionButton>
                </h2>
                <AccordionPanel>
                  <Box ml={4} my={2}>
                    <Text fontWeight="bold">Seller Details:</Text>
                    <Text ml={4} my={2}>
                      {fullTraceDetails?.seller?.name}{" "}
                      {`(${fullTraceDetails?.seller?.license})`}
                    </Text>
                    <Text fontWeight="bold"> Buyer Details: </Text>

                    <Text ml={4} my={2}>
                      {fullTraceDetails?.buyer?.name}{" "}
                      {`(${fullTraceDetails?.buyer?.license})`}
                    </Text>
                  </Box>
                  {fullTraceDetails?.procurements &&
                    fullTraceDetails?.procurements?.length > 0 && (
                      <UnorderedList listStyleType="none" ml={4} my={2}>
                        {fullTraceDetails?.procurements?.map((item) => (
                          <ListItem key={item?._id}>
                            <Badge colorScheme="green">{item?.id}</Badge>
                            <Box ml={4} my={4}>
                              <Text fontWeight={"bold"} fontSize={"sm"}>
                                {"Procurement Supplier:"}
                              </Text>

                              <Text fontSize={"sm"}>
                                {" "}
                                {`${item?.procurement_supplier?.firstName} ${item?.procurement_supplier?.lastName}`}
                              </Text>
                            </Box>
                          </ListItem>
                        ))}
                      </UnorderedList>
                    )}
                  {fullTraceDetails?.inventory &&
                    fullTraceDetails?.inventory?.length > 0 && (
                      <UnorderedList listStyleType="none" ml={4} my={2}>
                        {fullTraceDetails?.inventory?.map((item) => (
                          <ListItem key={item?._id}>
                            <Badge colorScheme="green">{item.id}</Badge>-{" "}
                            {item?.inventory_productClassification?.name} -{" "}
                            {item.quantityReceived}Kg
                          </ListItem>
                        ))}
                      </UnorderedList>
                    )}
                </AccordionPanel>
              </AccordionItem>
            </Accordion>

      </Box>



      {/* forward nodes of given TC number */}

      <Box bg={"brand.lightPowderBlue"}>
        <Accordion allowMultiple defaultIndex={isChildNode ? undefined : [0]}>
          {remainingNodes?.map((node, index) => (
            <AccordionItem key={node._id}>
              <h2>
                <AccordionButton>
                  <>
                    <Box
                      flex="1"
                      textAlign="left"
                      fontWeight="bold"
                      color={isChildNode ? "blue.500" : "black"}
                    >
                      {node?.tcNumber} - {node?.process}
                    </Box>
                    <Button
                      onClick={() => {
                        window.open(`/preview-tc/${node?.tcNumber}`, "_blank");
                      }}
                    >
                      <LinkIcon />
                    </Button>
                  </>
                </AccordionButton>
              </h2>
              <AccordionPanel>
                <Box ml={4} my={2}>
                  <Text fontWeight="bold">Seller Details:</Text>
                  <Text ml={4} my={2}>
                    {node?.seller?.name} {`(${node?.seller?.license})`}
                  </Text>
                  <Text fontWeight="bold"> Buyer Details: </Text>

                  <Text ml={4} my={2}>
                    {node?.buyer?.name} {`(${node?.buyer?.license})`}
                  </Text>
                </Box>
                {node?.procurements && node?.procurements?.length > 0 && (
                  <UnorderedList listStyleType="none" ml={4} my={2}>
                    {node?.procurements?.map((item) => (
                      <ListItem key={item?._id}>
                        <Badge colorScheme="green">{item?.id}</Badge>
                        <Box ml={4} my={4}>
                          <Text fontWeight={"bold"} fontSize={"sm"}>
                            Procurement Supplier:
                          </Text>

                          <Text fontSize={"sm"}>
                            {" "}
                            {`${item?.procurement_supplier?.firstName} ${item?.procurement_supplier?.lastName}`}
                          </Text>
                        </Box>
                      </ListItem>
                    ))}
                  </UnorderedList>
                )}
                {node?.inventory && node?.inventory?.length > 0 && (
                  <UnorderedList listStyleType="none" ml={4} my={2}>
                    {node?.inventory?.map((item) => (
                      <ListItem key={item?._id}>
                        <Badge colorScheme="green">{item.id}</Badge>-{" "}
                        {item?.inventory_productClassification?.name} -{" "}
                        {item.quantityReceived}Kg
                      </ListItem>
                    ))}
                  </UnorderedList>
                )}

                <ForwardNode forwardNodes={node.forwardNodes} isChildNode />
              </AccordionPanel>
            </AccordionItem>
          ))}
        </Accordion>
      </Box>

    </>
  );
};

const FullTrace = () => {
  const { tcNumber } = useParams();
  const [fullTraceDetails, setFullTraceDetails] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  ;
  ;
  const handleGoBack = () => {
    navigate(-1);
  };
  const navigate = useNavigate();

  //get full trace
  const getFullTrace = async (tcNumber) => {
    const url = `${process.env.REACT_APP_API_HOST}/api/trace/admin/full/${tcNumber}`;
    const token = localStorage.getItem("cu_user");
    setIsLoading(true);
    try {
      let response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response?.data?.status === "success") {
        setFullTraceDetails(response?.data?.data);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
  };

  useEffect(() => {
    getFullTrace(tcNumber);
  }, [tcNumber]);

  return (
    <Box>
      <Box
        display={"flex"}
        alignItems="center"
        cursor={"pointer"}
        onClick={handleGoBack}
      >
        <IoChevronBackCircleSharp color={"#52BBFF"} size={30} />
        &nbsp;
        <Text
          //#3958DC
          color={"#52BBFF"}
          fontSize={{ base: "sm", md: "sm", lg: "md" }}
          fontWeight={"800"}
          fontFamily={"font.roboto"}
        >
          Go Back
        </Text>
      </Box>
      <Text
        mt="2rem"
        color={"#141D43"}
        fontSize="2xl"
        fontWeight={"800"}
        fontFamily={"font.roboto"}
      >
        Full Trace Details
      </Text>
      {isLoading ? (
        <>Trace Loading...</>
      ) : (
        <>
          <Box p={4} bg={"brand.white"} padding={"1rem"} margin={"1rem"} borderRadius={"0.5rem"}>

            <ForwardNode
              forwardNodes={fullTraceDetails?.forwardNodes}
              fullTraceDetails={fullTraceDetails}
              isChildNode={false}
              parentNodes={fullTraceDetails?.parentNodes}
              searchTcNumber={tcNumber}
            />
          </Box>
        </>
      )}
    </Box>
  );
};

export default FullTrace;
